import Input from "components/OldInput";
import Context from "context/Global";
import { useContext, useEffect, useState } from "react";
import toast, { LoaderIcon } from "react-hot-toast";
import Api from "services/Api/Api";

const CollectionAtTerminalComponent = ({ updateAddition, option }) => {
    const [terminals, setTerminals] = useState([]);
    const [failed, setFailed] = useState(false);
    const context = useContext(Context);
    const carrier = context.quotation.service.name;
    const recipientPostalCode = context.order.receiver.postalCode;

    const fetchTerminals = async () => {
        try {
            const terminals = await Api.getTerminals(carrier);

            const sortedTerminals = sortTerminals(
                terminals,
                recipientPostalCode,
            );

            setTerminals(sortedTerminals);

            updateAddition({
                name: option.name,
                value: option.value,
            });
        } catch (error) {
            updateAddition({
                name: option.name,
                value: false,
            });
            setFailed(true);

            toast.error(
                "Misslyckades med att hämta terminaler, tjänsten är inte tillgänglig just nu.",
            );
        }
    };

    const sortTerminals = (terminals, inputPostcode) => {
        const getPostcodePrefix = (postalCode) =>
            postalCode.toString().slice(0, 2);

        if (!inputPostcode) {
            return [...terminals].sort((a, b) => a.name.localeCompare(b.name));
        }

        const normalizedPostcode = inputPostcode.replace(/[\s-]/g, "");

        if (!/^\d{5}$/.test(normalizedPostcode)) {
            return [...terminals].sort((a, b) => a.name.localeCompare(b.name));
        }

        const inputPrefix = Number(normalizedPostcode.slice(0, 2));

        return [...terminals].sort((a, b) => {
            const diffA = Math.abs(
                inputPrefix - Number(getPostcodePrefix(a.address.postalCode)),
            );
            const diffB = Math.abs(
                inputPrefix - Number(getPostcodePrefix(b.address.postalCode)),
            );
            return diffA - diffB;
        });
    };

    const updateSelectedTerminal = (terminalId) => {
        const selectedTerminal = terminals.find(
            (terminal) => terminal.terminalId === terminalId,
        );

        updateAddition({
            name: option.name,
            value: option.value,
            parameters: {
                terminal: selectedTerminal,
            },
        });
    };

    useEffect(() => {
        fetchTerminals();
    }, []);

    return (
        <div className="h-24">
            {terminals?.length > 0 ? (
                <div className="mt-2">
                    <label>Välj terminal för avhämtning:</label>
                    <Input
                        type="dropdown"
                        placeholder="Välj terminal"
                        onChange={(value) => updateSelectedTerminal(value)}
                        options={[
                            {
                                title: "Välj terminal",
                                value: "",
                                disabled: true,
                            },
                            ...terminals.map((terminal) => ({
                                title: `${terminal.name}, ${terminal.address.street}`,
                                value: terminal.terminalId,
                            })),
                        ]}
                    />
                </div>
            ) : failed ? (
                <div className="text-red-500 mt-2">
                    <p>
                        Misslyckades med att hämta terminaler, tjänsten kommer
                        ej att vara tillgänglig.
                    </p>
                    <p>
                        Kontakta support om du behöver hjälp med att boka
                        upphämtning på terminal.
                    </p>
                </div>
            ) : (
                <div className="flex items-center mt-2 gap-2">
                    <LoaderIcon />
                    <span>Laddar terminaler...</span>
                </div>
            )}
        </div>
    );
};

export default CollectionAtTerminalComponent;
